import React, { useState } from "react";
import SharedHelmet from ".././Helmet";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "Calculatrice d'acceleration en ligne";
const DESCRIPTION =
  "Calculatrice d'acceleration en ligne. Calculateur de physique en francais avec resultat rapide, unites claires et aide pratique pour exercices et revisions.";
const KEYWORDS =
  "acceleration, calculatrice physique, formule physique, exercices de physique, calcul en ligne";
const OG_URL = "https://do-calculate.com/calculator/fr/acceleration";

function AccelerationCalculator() {
  const [initialVelocity, setInitialVelocity] = useState("");
  const [finalVelocity, setFinalVelocity] = useState("");
  const [time, setTime] = useState("");
  const [acceleration, setAcceleration] = useState("");
  const [error, setError] = useState("");

  const handleCalculate = () => {
    if (!initialVelocity || !finalVelocity || !time) {
      setError(
        "Veuillez entrer la vitesse initiale, la vitesse finale et le temps correctement"
      );
      setAcceleration("");
      return;
    }
    const initialVelocityValue = parseFloat(initialVelocity);
    const finalVelocityValue = parseFloat(finalVelocity);
    const timeValue = parseFloat(time);
    if (
      isNaN(initialVelocityValue) ||
      isNaN(finalVelocityValue) ||
      isNaN(timeValue)
    ) {
      setError(
        "Veuillez entrer des valeurs correctes pour la vitesse initiale, la vitesse finale et le temps"
      );
      setAcceleration("");
      return;
    }
    const deltaVelocity = finalVelocityValue - initialVelocityValue;
    const deltaT = timeValue;
    const accelerationValue = deltaVelocity / deltaT;
    setAcceleration(accelerationValue.toFixed(2));
    setError("");
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  L'accélération peut être exprimée mathématiquement par deux lois principales 
                  selon les données du problème. Dans ce cas, nous utilisons la loi suivante:
                </p>
                <p>Accélération = Changement de vitesse / Changement de temps</p>
                <p>a = Δv / Δt</p>
                <p>Où:</p>
                <ul>
                  <li>a: l'accélération, mesurée en m/s².</li>
                  <li>
                    Δv: le changement de vitesse (vitesse finale - vitesse initiale) 
                    mesuré en m/s.
                  </li>
                  <li>
                    Δt: le changement de temps (temps final - temps initial) mesuré en s.
                  </li>
                </ul>
                <p>
                  Pour calculer l'accélération, entrez les valeurs nécessaires et cliquez sur 
                  "Calculer l'accélération" pour obtenir le résultat.
                </p>
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <div>
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label" style={{marginRight: "10px"}}>
                          Vitesse initiale (m/s)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="0"
                        value={initialVelocity}
                        onChange={(e) => setInitialVelocity(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label" style={{marginRight: "10px"}}>
                          Vitesse finale (m/s)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="60"
                        value={finalVelocity}
                        onChange={(e) => setFinalVelocity(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label" style={{marginRight: "10px"}}>Temps (secondes)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="4"
                        value={time}
                        onChange={(e) => setTime(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer l'accélération
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        Erreur: {error}
                      </p>
                    ) : (
                      <>
                        {acceleration !== "" && (
                          <>
                            <p className="p-3 mb-2 bg-success text-white">
                              Accélération (m/s²): {acceleration}
                            </p>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Quand utiliser ce calcul d'acceleration</h3></div>
              <div className="info-section-body">
                <p>Utilisez cette calculatrice quand vous connaissez deux vitesses et la duree correspondante. Elle convient tres bien aux problemes de mouvement rectiligne uniforme accelere en cours de physique.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Interpretion du resultat</h3></div>
              <div className="info-section-body">
                <p>Une acceleration positive signifie que la vitesse augmente. Une valeur negative indique un ralentissement. Plus la valeur absolue est grande, plus la variation de vitesse est rapide.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Erreurs frequentes a eviter</h3></div>
              <div className="info-section-body">
                <p>Ne melangez pas les unites (km/h et m/s) sans conversion. Verifiez aussi que le temps est saisi en secondes et qu'il correspond exactement a l'intervalle entre les deux vitesses.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccelerationCalculator;
